import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { formatDate, DATE_FORMATS } from '../Timestamp/functions';
import { IconSize } from '../Icons/IconWrap';
import shortenNumber from '../utils/shortenNumber';
import { getDeviationStats } from './helpers';
import FavouriteIcon from '../Icons/Favourite';
import CommentIcon from '../Icons/Comment';
import Eyecon from '../Icons/Eye';
import WhoTooltipWrapper from './WhoTooltipWrapper';
import { MobileContext } from '../Context';
import s from './ContentStatistic.scss';
export var ContentStatistic = function (_a) {
    var deviation = _a.deviation;
    var _b = useTranslation(), t = _b.t, i18n = _b.i18n;
    var isMobile = useContext(MobileContext);
    var _c = getDeviationStats(deviation), faves = _c.faves, comments = _c.comments, views = _c.views, viewsToday = _c.viewsToday, isFavouritable = _c.isFavouritable, isCommentable = _c.isCommentable, isViewCountable = _c.isViewCountable;
    var shorten = function (number) { return shortenNumber(number, 0, Math.floor); };
    return (React.createElement("div", { className: s['root'] },
        React.createElement("div", { className: s['stat-row'] },
            isFavouritable && (React.createElement(WhoTooltipWrapper, { deviation: deviation, userListType: "favourite" },
                React.createElement(FavouriteIcon, { size: IconSize.SMALL, disableDefaultColors: true, className: s['stat-icon'] }),
                ' ',
                shorten(faves))),
            isCommentable && (React.createElement(WhoTooltipWrapper, { deviation: deviation, userListType: "comment" },
                React.createElement(CommentIcon, { size: IconSize.SMALL, disableDefaultColors: true, className: classnames(s['stat-icon'], 
                    // don't ask, please
                    s['pixel-pushing-for-no-good-reason']) }),
                ' ',
                shorten(comments))),
            isViewCountable && (React.createElement("span", { className: s['stat'] },
                React.createElement(Eyecon, { size: IconSize.SMALL, disableDefaultColors: true, className: s['stat-icon'] }),
                ' ',
                shorten(views),
                " (",
                shorten(viewsToday),
                ' ',
                t('deviation.details.today'),
                ")"))),
        !isMobile && (deviation.publishedTime || deviation.isMature) && (React.createElement("div", { className: s['date-row'] },
            deviation.isMature && t('deviation.details.mature'),
            deviation.isMature && deviation.publishedTime && (
            // that is indeed meant to be two spaces each side
            React.createElement(React.Fragment, null, "\u00A0\u00A0|\u00A0\u00A0")),
            deviation.publishedTime && (React.createElement(React.Fragment, null,
                t('deviation.details.published'),
                ': ',
                formatDate(deviation.publishedTime, DATE_FORMATS.Date.Full, i18n.language)))))));
};
ContentStatistic.displayName = 'ContentStatistic';
export default ContentStatistic;
//# sourceMappingURL=ContentStatistic.js.map